import { render } from "./ClueView.vue?vue&type=template&id=4a0bde1a&scoped=true&ts=true"
import script from "./ClueView.vue?vue&type=script&lang=ts"
export * from "./ClueView.vue?vue&type=script&lang=ts"

import "./ClueView.vue?vue&type=style&index=0&id=4a0bde1a&scoped=true&lang=scss"

import exportComponent from "C:\\vue项目\\fushuliang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0bde1a"]])

export default __exports__